import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

import { log } from "utils/logger";

import "../css/Feedback.css";

export default function Feedback() {
  return (
    <div className="feedback">
      Have any <span className="suggestions feedbackText">suggestions?</span>{" "}
      <span className="compliments feedbackText">Compliments?</span>{" "}
      <span className="insults feedbackText">Insults?</span>{" "}
      <a
        className="feedbackTwitter"
        href={
          "https://twitter.com/intent/tweet?text=@rexbuilds" +
          "&hashtags=longwordsperminute"
        }
        target="_blank"
        rel="noreferrer"
        onClick={() => log("twitter_feedback_clicked")}
      >
        Tag me on Twitter <FontAwesomeIcon icon={faTwitter} />
      </a>
    </div>
  );
}
